import * as CONST from 'Reducers/Campaigns/const'

/**
 * Create city plan
 *
 * @param callbacks
 * @param campaignId
 * @param payload
 * @returns {{type, callbacks: *, campaignId: *, payload: *}}
 */
export function createCityPlan(callbacks, campaignId, payload) {
  return {
    type: CONST.CREATE_CITY_PLAN,
    callbacks,
    campaignId,
    payload,
  }
}

/**
 * Edit city plan
 *
 * @param callbacks
 * @param cityPlanId
 * @param payload
 * @returns {{type, callbacks: *, cityPlanId: *, payload: *}}
 */
export function editCityPlan(callbacks, cityPlanId, payload) {
  return {
    type: CONST.EDIT_CITY_PLAN,
    callbacks,
    cityPlanId,
    payload,
  }
}

/**
 * Delete city plan by id
 *
 * @param cityPlanId
 * @param callbackPath
 * @returns {{type, cityPlanId: *, callbackPath: *}}
 */
export function deleteCityPlanById(cityPlanId, callbackPath) {
  return {
    type: CONST.DELETE_CITY_PLAN_BY_ID,
    cityPlanId,
    callbackPath,
  }
}

/**
 * Create campaign
 *
 * @param callbacks
 * @param payload
 * @returns {{ payload: *}}
 */
export function createCampaign(payload) {
  return {
    type: CONST.CREATE_CAMPAIGN,
    payload,
  }
}

/**
 * Update campaign
 *
 * @param campaignId
 * @param payload
 * @returns {{payload: *}}
 */
export function updateCampaign(payload) {
  return {
    type: CONST.UPDATE_CAMPAIGN,
    payload,
  }
}

/**
 * Get campaign by id
 * @returns {{type}}
 */
export function getCampaignById(campaignId, options) {
  return {
    type: CONST.GET_CAMPAIGN_BY_ID,
    payload: { campaignId, options },
  }
}

/**
 * Clear campaign by id
 */
export function clearCampaignById() {
  return {
    type: CONST.CLEAR_CAMPAIGN_BY_ID,
  }
}

/**
 * Get campaigns
 * @returns Object
 */
export function getCampaigns(payload) {
  return {
    type: CONST.GET_CAMPAIGNS,
    payload: payload,
  }
}

/**
 * Get campaigns by client id
 * @returns Object
 */
export function getCampaignsByClientId(clientId) {
  return {
    type: CONST.GET_CAMPAIGNS_BY_CLIENT_ID,
    clientId,
  }
}

/**
 * Get city plan by id
 *
 * @param callbacks
 * @param cityPlanId
 * @returns {{type, callbacks: *, cityPlanId: *}}
 */
export function getCityPlanById(callbacks, cityPlanId) {
  return {
    type: CONST.GET_CITY_PLAN_BY_ID,
    callbacks,
    cityPlanId,
  }
}

/**
 * Clear in state city plan by id
 * @returns {{type}}
 */
export function clearCityPlanById() {
  return {
    type: CONST.CLEAR_CITY_PLAN_BY_ID,
  }
}

/**
 * Get city plans by campaign id for flyer codes form
 *
 * @param campaignId
 * @returns {{type, campaignId: *}}
 */
export function getCityPlansByCampaignIdForFlyerCodesForm(campaignId) {
  return {
    type: CONST.GET_CITY_PLANS_BY_CAMPAIGN_ID_FOR_FLYER_CODES_FORM,
    campaignId,
  }
}

/**
 * Set city plans by campaign id sort by
 *
 * @param sortBy
 * @returns {{type, sortBy: *}}
 */
export function setCityPlansByCampaignIdSortBy(sortBy) {
  return {
    type: CONST.SET_CITY_PLANS_BY_CAMPAIGN_ID_SORT_BY,
    sortBy,
  }
}

/**
 * Reset campaigns by client id
 * @returns Object
 */
export function resetCampaignsByClientId() {
  return {
    type: CONST.RESET_CAMPAIGNS_BY_CLIENT_ID,
  }
}

/**
 * Set campaigns filter by status value
 * @returns Object
 */
export function setCampaignsStatusFilter(statusFilter) {
  return {
    type: CONST.SET_CAMPAIGNS_STATUS_FILTER,
    statusFilter: statusFilter,
  }
}

/**
 * Set campaigns filter by status value for client view
 * @returns Object
 */
export function setClientViewCampaignsStatusFilter(statusFilter) {
  return {
    type: CONST.SET_CLIENT_VIEW_CAMPAIGNS_STATUS_FILTER,
    statusFilter: statusFilter,
  }
}

/**
 * Reset campaigns filter by status value for client view
 * @returns Object
 */
export function resetClientViewCampaignsStatusFilter() {
  return {
    type: CONST.RESET_CLIENT_VIEW_CAMPAIGNS_STATUS_FILTER,
  }
}

/**
 * Set campaigns filter by client value
 * @returns Object
 */
export function setCampaignsClientFilter(clientFilter) {
  return {
    type: CONST.SET_CAMPAIGNS_CLIENT_FILTER,
    clientFilter,
  }
}

/**
 * Set campaigns filter by country value
 * @param {string} countryFilter - country filter to be applied
 * @returns {Object}
 */
export function setCampaignsCountryFilter(countryFilter) {
  return {
    type: CONST.SET_CAMPAIGNS_COUNTRY_FILTER,
    countryFilter,
  }
}

/**
 * Upload conversion report
 *
 * @param callbacks
 * @param campaignId
 * @param payload
 * @returns {{type: *, callbacks: *, campaignId: *, payload: *}}
 */
export function uploadConversionReport(callbacks, campaignId, payload) {
  return {
    type: CONST.UPLOAD_CONVERSION_REPORT,
    callbacks,
    campaignId,
    payload,
  }
}

/**
 * Add conversion report
 *
 * @param callbacks
 * @param campaignId
 * @param payload
 * @returns {{type, callbacks: *, campaignId: *, payload: *}}
 */
export function addConversionReport(callbacks, campaignId, payload) {
  return {
    type: CONST.ADD_CONVERSION_REPORT,
    callbacks,
    campaignId,
    payload,
  }
}

/**
 * Get the results of a campaign
 */
export function getCampaignResults(campaignId) {
  return {
    type: CONST.GET_CAMPAIGN_RESULTS,
    payload: { campaignId },
  }
}
